import { createSlice } from "@reduxjs/toolkit";

const hodMessagesSlice = createSlice({
  name: "hodMessages",
  initialState: {
    hodMessages: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Fetch HOD messages actions
    fetchHODMessagesStart(state) {
      state.hodMessages.loading = true;
      state.hodMessages.error = null;
    },
    fetchHODMessagesSuccess(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.data = action.payload;
    },
    fetchHODMessagesFailure(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.error = action.payload;
    },

    // Add HOD message actions
    addHODMessageStart(state) {
      state.hodMessages.loading = true;
      state.hodMessages.error = null;
    },
    addHODMessageSuccess(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.data = [...state.hodMessages.data, action.payload];
    },
    addHODMessageFailure(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.error = action.payload;
    },

    // Update HOD message actions
    updateHODMessageStart(state) {
      state.hodMessages.loading = true;
      state.hodMessages.error = null;
    },
    updateHODMessageSuccess(state, action) {
      state.hodMessages.loading = false;
      const updatedMessage = action.payload;
      state.hodMessages.data = state.hodMessages.data.map((message) =>
        message.id === updatedMessage.id ? updatedMessage : message
      );
    },
    updateHODMessageFailure(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.error = action.payload;
    },

    // Delete HOD message actions
    deleteHODMessageStart(state) {
      state.hodMessages.loading = true;
      state.hodMessages.error = null;
    },
    deleteHODMessageSuccess(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.data = state.hodMessages.data.filter(
        (message) => message.id !== action.payload
      );
    },
    deleteHODMessageFailure(state, action) {
      state.hodMessages.loading = false;
      state.hodMessages.error = action.payload;
    },
  },
});

export const {
  fetchHODMessagesStart,
  fetchHODMessagesSuccess,
  fetchHODMessagesFailure,
  addHODMessageStart,
  addHODMessageSuccess,
  addHODMessageFailure,
  updateHODMessageStart,
  updateHODMessageSuccess,
  updateHODMessageFailure,
  deleteHODMessageStart,
  deleteHODMessageSuccess,
  deleteHODMessageFailure,
} = hodMessagesSlice.actions;

export default hodMessagesSlice.reducer;
